import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const PreparingDeviceIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28.57 20"
      {...props}
    >
      <g id="a" />
      <g id="b">
        <g id="c">
          <g>
            <g>
              <path d="M24.35,11.69c-2.18,0-3.97,1.79-3.97,3.97s1.79,3.97,3.97,3.97,3.97-1.79,3.97-3.97-1.79-3.97-3.97-3.97Zm0,7.44c-1.91,0-3.47-1.56-3.47-3.47s1.56-3.47,3.47-3.47,3.47,1.56,3.47,3.47-1.56,3.47-3.47,3.47Z" />
              <path d="M24.6,12.93h-.5v2.73c0,.15,.1,.25,.25,.25h1.49v-.5h-1.24v-2.48Z" />
            </g>
            <g>
              <path style={{ fill: 'none' }} d="M4,2V14h6c.3,0,.5,.1,.7,.3l.7,.7h5.2l.7-.7c.2-.2,.4-.3,.7-.3h1.8c.64-1.76,2.26-3.02,4.2-3.16V2H4Z" />
              <path style={{ fill: 'none' }} d="M17.7,16.7c-.2,.2-.4,.3-.7,.3h-6c-.3,0-.5-.1-.7-.3l-.7-.7H2v1c0,.6,.4,1,1,1H20.12c-.33-.6-.54-1.28-.59-2h-1.13l-.7,.7Z" />
              <path d="M20.12,18H3c-.6,0-1-.4-1-1v-1h7.6l.7,.7c.2,.2,.4,.3,.7,.3h6c.3,0,.5-.1,.7-.3l.7-.7h1.13c0-.11-.03-.22-.03-.34,0-.59,.12-1.14,.31-1.66h-1.8c-.3,0-.5,.1-.7,.3l-.7,.7h-5.2l-.7-.7c-.2-.2-.4-.3-.7-.3H4V2H24V10.84c.12,0,.23-.04,.35-.04,.58,0,1.13,.12,1.65,.31V2c0-1.1-.9-2-2-2H4c-1.1,0-2,.9-2,2V14H1c-.6,0-1,.4-1,1v2c0,1.7,1.3,3,3,3H22.2c-.89-.44-1.61-1.14-2.09-2Z" />
            </g>
          </g>
        </g>
      </g>
    </StyledSVGIcon>
  );
};